import React from "react";

const Items = ({ items, onItemsChange }) => {
  const handleItemChange = (e, idx) => {
    const { name, value } = e.target;
    const updatedItems = [...items];
    updatedItems[idx] = { ...updatedItems[idx], [name]: value };
    onItemsChange(updatedItems);
  };

  const handleQuantityChange = (e, itemIdx, qtyIdx) => {
    const { name, value } = e.target;
    const updatedItems = [...items];
    const newQuantities = [...updatedItems[itemIdx].itemQuantity];
    newQuantities[qtyIdx] = { ...newQuantities[qtyIdx], [name]: value };
    updatedItems[itemIdx].itemQuantity = newQuantities;
    onItemsChange(updatedItems);
  };

  const handleWeightChange = (e, idx) => {
    const { name, value } = e.target;
    const updatedItems = [...items];
    updatedItems[idx].itemWeight = {
      ...updatedItems[idx].itemWeight,
      [name]: value
    };
    onItemsChange(updatedItems);
  };

  const addItem = () => {
    const newItem = {
        itemLineNumber: (items.length + 1).toString(),
        itemProductCode: "PROD" + (items.length + 1),
        itemDescription: "Sample Item " + (items.length + 1),
        itemQuantity: [
          { containerType: "Bag", quantity: "10" },
          { containerType: "Pallet", quantity: "5" }
        ],
        itemWeight: {
          totalWeight: "100",
          weightQualifier: "KG",
          unitOfMeasurement: "Cubic M",
          totalVolume: "12.5"
        }
      };
      
    onItemsChange([...items, newItem]);
  };

  const removeItem = (idx) => {
    const updatedItems = items.filter((_, i) => i !== idx);
    onItemsChange(updatedItems);
  };

  const addQuantity = (itemIdx) => {
    const updatedItems = [...items];
    updatedItems[itemIdx].itemQuantity.push({ containerType: "", quantity: "" });
    onItemsChange(updatedItems);
  };

  return (
    <div className="mt-6">
      <h3 className="text-lg font-bold mb-4">Items</h3>
      {items.map((item, idx) => (
        <div key={idx} className="border rounded p-4 mb-4 bg-gray-50">
          <div className="flex justify-between items-center">
            <h4 className="font-semibold">Item #{item.itemLineNumber}</h4>
            <button onClick={() => removeItem(idx)} className="bg-red-500 text-white px-3 py-1 rounded">
              Remove
            </button>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
            <div>
              <label className="block font-medium mb-1">Product Code</label>
              <input
                type="text"
                name="itemProductCode"
                value={item.itemProductCode}
                onChange={(e) => handleItemChange(e, idx)}
                className="border rounded p-2 w-full"
              />
            </div>
            <div>
              <label className="block font-medium mb-1">Description</label>
              <input
                type="text"
                name="itemDescription"
                value={item.itemDescription}
                onChange={(e) => handleItemChange(e, idx)}
                className="border rounded p-2 w-full"
              />
            </div>
          </div>

          <h5 className="font-semibold mt-4 mb-2">Quantities</h5>
          {item.itemQuantity.map((qty, qtyIdx) => (
            <div key={qtyIdx} className="grid grid-cols-2 gap-4 mb-2">
              <input
                type="text"
                name="containerType"
                value={qty.containerType}
                placeholder="Container Type"
                onChange={(e) => handleQuantityChange(e, idx, qtyIdx)}
                className="border rounded p-2 w-full"
              />
              <input
                type="text"
                name="quantity"
                value={qty.quantity}
                placeholder="Quantity"
                onChange={(e) => handleQuantityChange(e, idx, qtyIdx)}
                className="border rounded p-2 w-full"
              />
            </div>
          ))}
          <button onClick={() => addQuantity(idx)} className="bg-blue-400 text-white px-3 py-1 rounded mb-4">
            + Add Quantity
          </button>

          <h5 className="font-semibold mb-2">Weight Info</h5>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
            {Object.entries(item.itemWeight).map(([key, val]) => (
              <div key={key}>
                <label className="block font-medium mb-1">{key}</label>
                <input
                  type="text"
                  name={key}
                  value={val}
                  onChange={(e) => handleWeightChange(e, idx)}
                  className="border rounded p-2 w-full"
                />
              </div>
            ))}
          </div>
        </div>
      ))}

      <button onClick={addItem} className="bg-blue-500 text-white px-4 py-2 rounded">
        + Add Item
      </button>
    </div>
  );
};

export default Items;
